import { LocationZerezes } from './LocationZerezes';
import { User } from './User';

export class Session {
  token?: string;
  user?: User;
  locations?: LocationZerezes[];
  date?: Date;
  sessionExpiresAtUtcDate?: Date|null;
  sessionExpiresAtAmericaSaoPauloDate?: Date|null;
}